<template>
  <div class="teaching-score-grade-input-label">
    <i class="el-icon-back"></i>
    <div class="label-inner">
      <div class="theme-text">{{current.name}}</div>
      <div class="range">
        <span>[</span>
        <span>{{getRange}}</span>
        <span>{{current.includeMax ? ']' : ')'}}</span>
      </div>
    </div>
    <i class="el-icon-right"></i>
  </div>
</template>

<script>
export default {
  name: 'TeachingScoreGradeInputLabel',
  props: {
    current: {
      type: Object,
      required: true
    },
    next: Object,
    maxScore: Number,
    minScore: Number
  },
  computed: {
    fromMaximum () {
      if (this.next) {
        return this.next.maximum
      } else {
        return this.minScore
      }
    },
    getRange () {
      const fromMaximum = this.fromMaximum
      const toMaximum = this.current.maximum
      if (typeof fromMaximum === 'number' && typeof toMaximum === 'number') {
        return `${fromMaximum}, ${toMaximum}`
      } else {
        return '--, --'
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-grade-input-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: 14px;
      font-weight: bold;
    }
    & > .label-inner {
      line-height: 120%;
      & > .range {
        margin-top: 1px;
        color: #909399;
        transform: scale(.9);
      }
    }
  }
</style>
